import React from "react"
import { Dayjs } from "dayjs"
import { ICustomFieldTemplate } from "../../entities/job/interface"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Box, ThemeProvider, Typography } from "@mui/material"
import EventIcon from "@mui/icons-material/Event"
import { DateTimePicker } from "@mui/x-date-pickers"
import { theme } from "../../styles/theme"

interface Props {
    field: ICustomFieldTemplate
    value: Dayjs | null
    error?: string
    onChange: (id: string, value: Dayjs | null) => void
    isEditable: boolean
}

const DateTimeComponent: React.FC<Props> = ({ field, value, error, onChange, isEditable }) => {
    const [openDateTimePicker, setOpenDateTimePicker] = React.useState(false)
    return (
        <ThemeProvider theme={theme}>
            <Box width={"100%"} display={"flex"} flexDirection={"column"}>
                <Box
                    width={"100%"}
                    padding={"10px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    bgcolor={"#027BBA"}
                    borderRadius={"10px"}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                            value={value}
                            disablePast
                            open={openDateTimePicker}
                            format="MM/DD/YYYY hh:mm"
                            disabled={!isEditable}
                            onChange={(newValue) => onChange(field.customFieldTemplateId, newValue)}
                            onClose={() => setOpenDateTimePicker(false)}
                            slotProps={{
                                textField: {
                                    error: !!error,
                                    inputProps: {
                                        style: {
                                            cursor: isEditable ? "pointer" : "not-allowed",
                                        },
                                    },
                                    onClick: () => setOpenDateTimePicker(true),
                                },
                                actionBar: {
                                    actions: ["clear", "today"],
                                },
                            }}
                            sx={{
                                fontSize: "18px",
                                color: "white",
                                "& .MuiInputBase-root": {
                                    color: "white",
                                    height: 30,
                                    fontSize: "15px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "none",
                                    border: "0px",
                                },
                                "& .MuiPickersModal-root": {
                                    backgroundColor: "#F0F0F0",
                                    color: "white",
                                    width: "100%",
                                },
                                "& .MuiOutlinedInput-root .MuiInputBase-input::placeholder": {
                                    color: "white",
                                },
                                "& .MuiInputAdornment-root": {
                                    display: "none",
                                },
                            }}
                        />
                    </LocalizationProvider>

                    <EventIcon
                        style={{
                            color: isEditable ? "#FFFFFF" : "#A0A0A0", // Change color if not editable
                            cursor: isEditable ? "pointer" : "not-allowed", // Change cursor style if not editable
                        }}
                        onClick={() => {
                            if (!isEditable) return
                            setOpenDateTimePicker(true)
                        }}
                    />
                </Box>
                <Typography variant="caption" color="error" fontSize={"15px"}>
                    {error}
                </Typography>
            </Box>
        </ThemeProvider>
    )
}

export default DateTimeComponent
